import { render } from "./ListeProduitIventairePage.vue?vue&type=template&id=d9808f4e&ts=true"
import script from "./ListeProduitIventairePage.vue?vue&type=script&lang=ts"
export * from "./ListeProduitIventairePage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__